import { gql } from "@apollo/client";

export const GET_ORIGEN_MATRICULA_DERIVADOR = gql`
query GetAllOrigenMatricula {
  allOrigenMatricula {
    idOrigenMatricula,
    descripcion,
    abreviacion
  }
}
`;

export const adaptOrigenMatriculaDerivador = (OrigenMatriculaDerivador) => {
  return {
    id: OrigenMatriculaDerivador?.idOrigenMatricula,
    displayName: OrigenMatriculaDerivador?.descripcion,
    abreviacion: OrigenMatriculaDerivador?.abreviacion
  };
};

export const adaptOrigenMatriculaDerivadorArray = (
allOrigenMatriculaDerivador) =>
{
  return structuredClone(allOrigenMatriculaDerivador)?.
  map((OrigenMatriculaDerivador) => adaptOrigenMatriculaDerivador(OrigenMatriculaDerivador));
};